import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	slackWorkspaceConnectionRemoveButton: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workplace-connection-settings.workspaces.workspace.slack-workspace-connection-remove-button',
		defaultMessage: 'Disconnect workspace from this service project',
		description: 'Message for the remove workspace button',
	},
	workspaceImageLabel: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workplace-connection-settings.workspaces.workspace.workspace-image-label',
		defaultMessage: 'Workspace',
		description: 'Label of workspace image',
	},
	toggleLabel: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workplace-connection-settings.workspaces.workspace.toggle-label',
		defaultMessage: 'Enable/Disable workspace',
		description: 'Label of workspace toggle',
	},
	slackConnectionToProjectEnabledSuccessFlagTitle: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workplace-connection-settings.workspaces.workspace.slack-connection-to-project-enabled-success-flag-title',
		defaultMessage: 'Workspace connected to project',
		description: 'The title for successful connection of workplace',
	},
	slackConnectionToProjectEnabledSuccessFlagText: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workplace-connection-settings.workspaces.workspace.slack-connection-to-project-enabled-success-flag-text',
		defaultMessage:
			'Agents can start creating Slack channels in this workspace. You can connect a new one or remove it at any time',
		description: 'The message content for successful connection of workplace',
	},
});
